import { render, staticRenderFns } from "./NewYD.vue?vue&type=template&id=3c124c76&"
import script from "./NewYD.vue?vue&type=script&lang=js&"
export * from "./NewYD.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports